import React, { useEffect, useState } from "react";
import { Input, Menu, Spin, Tag, Tooltip } from "antd";
import Style from "./index.module.scss";
import { findTermCourseTreeList, NavItemProps, NavProps } from "../../service";
import useRequest from "../../../../utils/useRequest";
import className from "classnames";
import { getCurrentDate } from "../../../../service/service";
import lodash from "lodash-es";

const { Search } = Input;

interface Props {
    onSelect: (item: NavItemProps) => void;
}
const Index = ({ onSelect }: Props) => {
    const { SubMenu } = Menu;

    const [query, setQuery] = useState<NavProps>({
        keyword: ""
    });
    const [currentDate, { loading: loadingDate }] = useRequest(getCurrentDate);

    const [data, { loading }] = useRequest(
        () => findTermCourseTreeList(query),
        {},
        [query]
    );
    function onChanges(keyword: string) {
        setQuery({ keyword });
    }

    function selectEvent({ key }: { key: string }) {
        //key 组成 双层数组 - 分割，精确定位选择item 返回到上层
        const [index, courseDomainsIndex] = key.split("-");
        const selected =
            data?.[parseInt(index)].courseDomains[parseInt(courseDomainsIndex)];
        if (selected) {
            onSelect(selected);
        }
    }

    const [nowBatchIndex, setNowBatchIndex] = useState(-1);
    useEffect(() => {
        if (data && currentDate) {
            const now = currentDate.batchNo;
            const index = lodash.findIndex(data, { batchNo: now });
            const group = data[index];
            setNowBatchIndex(index);
            if (group.courseDomains.length > 0) {
                onSelect(data[index].courseDomains[0]);
            }
        }
    }, [data, currentDate]);

    if (!data || !currentDate || nowBatchIndex < 0) {
        return null;
    }

    return (
        <div className={Style.root}>
            <Spin style={{ height: "100%" }} spinning={loading}>
                <div className={Style.navs}>
                    <div className={Style.inputBox}>
                        <Search
                            className="BORDER-RADIUS-2"
                            placeholder="输入课程名称或编码"
                            onSearch={onChanges}
                        />
                    </div>
                    <div className={Style.sping}>
                        <Menu
                            mode="inline"
                            className={Style.menu}
                            defaultOpenKeys={[currentDate.batchNo]}
                            defaultSelectedKeys={[`${nowBatchIndex}-0`]}
                            onSelect={selectEvent}>
                            {data?.map((item, index) => {
                                return (
                                    <SubMenu
                                        key={item.batchNo}
                                        title={
                                            <div className={Style.flex}>
                                                {item.batchName}
                                                <b>{item.batchNo}</b>
                                                {item.batchNo ===
                                                    currentDate?.batchNo && (
                                                    <Tag
                                                        color="blue"
                                                        className={className(
                                                            "BORDER-RADIUS-2",
                                                            Style.tag
                                                        )}>
                                                        当前学期
                                                    </Tag>
                                                )}
                                            </div>
                                        }>
                                        {item.courseDomains.map(
                                            (axios, axiosIndex) => {
                                                return (
                                                    <Menu.Item
                                                        key={[
                                                            index,
                                                            axiosIndex
                                                        ].join("-")}>
                                                        {axios?.coursename
                                                            ?.length > 5 ? (
                                                            <Tooltip
                                                                placement="topLeft"
                                                                title={
                                                                    axios.coursename
                                                                }>
                                                                <span
                                                                    className={
                                                                        Style.navItem
                                                                    }>
                                                                    [
                                                                    {
                                                                        axios.courseno
                                                                    }
                                                                    -
                                                                    {
                                                                        axios.courseseq
                                                                    }
                                                                    ]
                                                                    {
                                                                        axios.coursename
                                                                    }
                                                                </span>
                                                            </Tooltip>
                                                        ) : (
                                                            <span
                                                                className={
                                                                    Style.navItem
                                                                }>
                                                                [
                                                                {axios.courseno}
                                                                -
                                                                {
                                                                    axios.courseseq
                                                                }
                                                                ]
                                                                {
                                                                    axios.coursename
                                                                }
                                                            </span>
                                                        )}
                                                    </Menu.Item>
                                                );
                                            }
                                        )}
                                    </SubMenu>
                                );
                            })}
                        </Menu>
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default Index;
